import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class DevStyles extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    if (!this.props.shouldRender) {
      return null;
    }

    return (
      <link href={`${this.props.staticUrl}/css/main.css`} rel="stylesheet" />
    );
  }
}

DevStyles.propTypes = {
  staticUrl: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    shouldRender: state.config.env === 'development',
    staticUrl: state.config.staticUrl
  };
}

export default connect(mapStateToProps)(DevStyles);
